import { getRangeInlineNodeNames } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';
export function getRendererRangeInlineNodeNames(_ref) {
  var actions = _ref.actions,
    pos = _ref.pos;
  if (!fg('editor_inline_comments_on_inline_nodes')) {
    return undefined;
  }
  var doc = actions.doc;
  if (!pos || !doc) {
    return undefined;
  }
  var inlineNodeNames = getRangeInlineNodeNames({
    doc: doc,
    pos: pos
  });
  return inlineNodeNames;
}